import { Component, EventEmitter, Input, Output } from '@angular/core';
import { environment } from '@env/environment';

@Component({
    selector: 'app-popup-flight-itinerary',
    templateUrl: './popup-flight-itinerary.component.html',
    styleUrls: ['./popup-flight-itinerary.component.scss'],
})
export class PopupFlightItineraryComponent {
    @Input() itineraries: any[];
    @Output() clickCancel = new EventEmitter<any>();
    @Output() nextEmit = new EventEmitter<any>();

    isValidateItinerary: boolean = false;
    listNumStopDate: number[] = [];
    listChosenItinerary: boolean[] = [];
    baseImage = environment.STORAGE_SERVICE_API_BASE_PATH_ID_IMAGE;

    ngOnInit() {
        // Calculate date stop of itinerary
        this.itineraries.forEach((item, index) => {
            const numStop = this.calculateDateStop(
                item?.segments?.[0]?.date_departure_at,
                item?.segments?.[item?.segments?.length - 1]?.date_arrival_at
            );
            this.listNumStopDate[index] = numStop;
            this.listChosenItinerary[index] = false;
        })
    }

    onClickItinerary(index: number) {
        this.listChosenItinerary[index] = !this.listChosenItinerary[index];
    }

    calculateDateStop(startDate?: string, endDate?: string): number {
        if (!startDate || !endDate) return 0;
        const start = new Date(startDate).getTime();
        const end = new Date(endDate).getTime();
        
        return Math.max(0, (end - start) / (1000 * 3600 * 24));
    }

    replaceWithDefaultImage(event: any): void {
        event.target.src = 'assets/images/user-management/default-image.jpg';
    }

    onClickCancel() {
        this.clickCancel.emit();
    }

    validChosen() {
        return this.listChosenItinerary.some(item => item);
    }

    onClickContinue() {
        const validChosen = this.validChosen();

        if (!validChosen) {
            this.isValidateItinerary = true;
        } else {
            this.nextEmit.emit(this.listChosenItinerary);
        }
    }
}
